<template>
  <div>
    <header-top/>
    <mobile-menu/>
    <router-view/>
    <!-- <footer-bottom/> -->
  </div>
</template>

<script>
import HeaderTop from "@/components/Header";
import FooterBottom from "@/components/Footer";
import MobileMenu from "@/components/Mobile-Menu";
import "animate.css";

export default {
  components: {
    HeaderTop,
    FooterBottom,
    MobileMenu
  },
  computed: {
    menuVisible() {
      return this.$store.state.menuVisible;
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/sass/main.scss";
.hidden {
  opacity: 0;
}
.initialOpacity {
  animation: k_fade_out 400ms ease-in-out;
  animation-fill-mode: forwards;
}
@keyframes k_fade_out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0 !important;
  }
}
.page {
  width: inherit;
  position: fixed;
}
</style>
